import axiosInstance from '../../../../config/axiosInstance';
const  CommentTemplateService = {
    async GetAllCommentTemplates(redirectCallback) {
        try {            
           const ClientID=localStorage.getItem('CompanyID');
           const response = await axiosInstance.get(`/Setup/GetCommentTemplate?ClientID=${ClientID}`);
           return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteComment(ID,redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Setup/DeleteCommentTemp?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default CommentTemplateService;